// extracted by mini-css-extract-plugin
module.exports = {"animationView":"AnimationView_animationView__2eeiT","zoomView":"AnimationView_zoomView__3tirG"};